import { ONE_SLOT_MINUTES } from '../../constants';
import { getNonWorkingHoursTopPosition, getNonWorkingHoursHeight } from '../../utils/calendar.utils';
import {
  AllocationCalendarClosedPeriod,
  AllocationCalendarNonWorkingHours,
} from './allocation-calendar-non-working-hours.model';
import { DatepickerRangeModel } from '../../../../../../common';
import { isAfter, isBefore } from 'date-fns';

export class AllocationCalendarNonWorkingHoursSlot {
  top: number;
  height: number;
  start: Date;
  end: Date;

  private oneMinutePxHeight: number;

  constructor(
    public nonWorkingHours: AllocationCalendarNonWorkingHours | AllocationCalendarClosedPeriod,
    public timeFrame: DatepickerRangeModel,
    private oneSlotPxHeight: number,
  ) {
    this.initStart();
    this.initEnd();
    this.initOneMinutePxHeight();
    this.initTop();
    this.initHeight();
  }

  private initStart(): void {
    const timeFrameStart: Date = new Date(this.timeFrame.start);

    this.start = isAfter(timeFrameStart, this.nonWorkingHours.start) ? timeFrameStart : this.nonWorkingHours.start;
  }

  private initEnd(): void {
    const timeFrameEnd: Date = new Date(this.timeFrame.end);

    this.end = isBefore(timeFrameEnd, this.nonWorkingHours.end) ? timeFrameEnd : this.nonWorkingHours.end;
  }

  private initTop(): void {
    if (isAfter(this.start, this.nonWorkingHours.end)) {
      return;
    }

    this.top = getNonWorkingHoursTopPosition(new Date(this.timeFrame.start), this.start, this.oneMinutePxHeight);
  }

  private initOneMinutePxHeight(): void {
    this.oneMinutePxHeight = this.oneSlotPxHeight / ONE_SLOT_MINUTES;
  }

  private initHeight(): void {
    this.height = getNonWorkingHoursHeight(this.start, this.end, this.oneMinutePxHeight);
  }
}
